import {type PayloadAction, createSlice} from '@reduxjs/toolkit';
import type {RootState} from '../../store/types';
import type {AgentItemsState} from './types';

const initialState: AgentItemsState = [];

const agentItemsSlice = createSlice({
  name: 'agentItems',
  initialState,
  reducers: {
    agentItemsUpdated: (_state, action: PayloadAction<AgentItemsState>) => {
      return action.payload;
    },
    agentItemsCleared: () => {
      return initialState;
    },
  },
});

export const {agentItemsUpdated, agentItemsCleared} = agentItemsSlice.actions;
export const selectAgentItems = (state: RootState) => state.agentItems;

export default agentItemsSlice;
